/* ===== Form Management ===== */
import { $ } from '../utils/helpers.js?v=82.86';

export function resetRegisterForm() {
  ['regName', 'regEmail', 'regPassword', 'regCompany', 'regCui'].forEach(id => {
    const el = $(id);
    if (el) el.value = '';
  });
  ['opGDPR', 'opDPA', 'opTruth', 'opVendorMKT'].forEach(id => {
    const el = $(id);
    if (el) el.checked = false;
  });
}
